import { keepPreviousData, useInfiniteQuery } from '@tanstack/react-query'

import { roomQueries, TRoomsSearchParams } from '@/entities/room'

type Props = {
  filters: TRoomsSearchParams
}

export const useRoomsQuery = ({ filters }: Props) => {
  const result = useInfiniteQuery({
    ...roomQueries.roomList(filters),
    enabled: false,
    select: data => {
      return {
        rooms: data.pages.flatMap(page => page.rooms.content),
        airbridgeEvent: data.pages.at(-1)?.airbridgeEvent,
        isFirstPage: data.pages.length === 1,
      }
    },
    placeholderData: keepPreviousData,
  })

  return {
    ...result,
    data: {
      rooms: result.data?.rooms ?? [],
      airbridgeEvent: result.data?.airbridgeEvent ?? null,
      isFirstPage: result.data?.isFirstPage ?? true,
    },
  }
}
